@import 'src/styles/common/_colors.scss';

/* ----------------------------- BUTTONS -------------------------------- */


.baseButton{
	margin-right: 2px;
	vertical-align: middle;
	text-shadow: 0 1px 1px $text-shadow-color;
	box-shadow: 0 1px 1px $white-variant-3;	
	border-radius: 3px;
	color: $white;
	box-sizing: content-box;
	outline: none;
	font-size: 0.6875rem;
	text-align: center;
	font-weight: bold;		
}
.button {
	@extend .baseButton;
	line-height: 24px;
	position: relative;
	padding: 0 12px;
	display: inline-block;
	height: 24px;
	min-width: 20px;
	padding: 0 12px;	
	margin-right: 2px;
	
}
.buttonMini {
	@extend .baseButton;
	display: inline-flex;
    align-items: center;
	padding: 4px 14px;
	line-height: 1rem;
	span {
		vertical-align: top;
		font-size: 0.625rem;
	}
}



.button:active,
.button.active,
.button.selected {
	background: linear-gradient(to bottom, $black 0%, $light-green 100%);
}

.button[disabled],
.button[disabled]:hover,
.button.disabled,
.button.green.disabled,
.button.green.disabled:hover {
	color: $gray-variant-11;
	text-shadow: none;
	box-shadow: 0 1px 1px hsl(0deg 0% 100% / 30%);
	background: linear-gradient(180deg, $gray-variant-11 0%, $gray-variant-15 100%);
	cursor: default;
	border: none;
}

.button.disabled .icon {
	color: $button-disabled-icon-color;
}

.buttonDark {
	border: 1px solid $black;
	background: linear-gradient(180deg, $gray-variant-13, $gray-variant-14);
	&:hover {
		background: linear-gradient(180deg, $gray-variant-11, $gray-variant-15);
	}
}
.buttonDarkActive{
	background: linear-gradient(180deg, $dark-gray, $light-green);
	&:hover {
		background: linear-gradient(180deg, $dark-gray, $light-green);
	}
}
// .button.dark.disabled {
// 	color: $button-dark-disabled-icon-color;
// 	box-shadow: 0 1px 1px $light-gray-variant-1;
// 	background: linear-gradient(to bottom, $mightnight-black 0%, $dialog-background-color 100%);
// }

// .button.dark.disabled .icon {
// 	color: $button-dark-disabled-icon-color;
// }


.buttonBlue {	
	border: 1px solid $cloud-blue;
	background: linear-gradient(180deg,$blue-variant-color-1,$blue-variant-color-2);
	// background: linear-gradient(to bottom, $blue-variant-color-1 0%, $blue-variant-color-2 100%);
	&:not(disabled){
		&:hover {
			background: linear-gradient(180deg,$blue-variant-color-3 0,$blue-variant-color-4);
		}
	}
	
}

.buttonGreen {
	background: linear-gradient(180deg,$green 0,$green-variant-1);
    border: 1px solid $green-variant-4;
	&:hover {
		background: linear-gradient(to bottom, $green-variant-2 0%, $green-variant-4 100%);
	}
}
.buttonRed {
	background: linear-gradient(180deg,$red 0,$light-red);
    border: 1px solid $light-red;
	&:hover {
		background: linear-gradient(to bottom, $light-red 0%, $light-red 100%);
	}
}

.buttonTransparent {
	background-color: transparent;
    background-repeat: no-repeat;
    border: none;
    cursor: pointer;
    box-shadow: none;
	&:active {
		background: none !important;
	}
}

.button.green:active {
	background: linear-gradient(to bottom, $green-variant-2 0%, $green-variant-4 100%);
}

.button.green:disabled,
.button.green.disabled,
.button.green:disabled:hover,
.button.green.disabled:hover {
	text-shadow: 0 1px 1px $text-shadow-color;
	box-shadow: 0 1px 1px $white;
	box-sizing: content-box;
	outline: none;
	margin-right: 2px;
	vertical-align: middle;
	background: linear-gradient(to bottom, $gray-variant-11 0%, $black 100%);
	border: 0;
	color: $button-green-disabled-icon-color;
}

/* ----------------------------- BUTTONS GROUP -------------------------------- */
.button-group {
	display: inline-block;
	vertical-align: middle;
	padding-right: 1px;
}

.button-group .button {
	display: block;
	position: relative;
	float: left;
	margin-right: -1px;
	border-radius: 0;
}

.button-group .button:first-child {
	border-top-left-radius: 3px;
	border-bottom-left-radius: 3px;
}

.button-group .button:last-child {
	border-top-right-radius: 3px;
	border-bottom-right-radius: 3px;
}

.iconButton{
	height: 28px;
    width: 45px;
    align-items: center;
    display: inline-flex;
    justify-content: center;
	span{
		font-size: 0.825rem;
		color: $white;
	}
}